import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import cn from "classnames";
import styles from "./View.module.sass";
import Card from "../../../../../../components/Card";
import Icon from "../../../../../../components/Icon";
import Table from "../../Table/index";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import {
  get_tag_category,
  create_tags_category,
} from "../../../../../../API/TagsSettings";
import CustomToast from "../../../../../../components/CustomToast";
import TextInput from "../../../../../../components/TextInput";
import Modal from "../../../../../../components/Modal";
import Panel from "../Panel";

const TagView = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const tag = location.state?.tag;
  const showToast = CustomToast();

  const [visible, setVisible] = useState(false);
  const [tagCategory, setTagCategory] = useState([]);
  const [visibleModal, setVisibleModal] = useState(false);

  const fetchAllTagCategory = async () => {
    const res = await get_tag_category(id);
    setTagCategory(res.data);
  };

  useEffect(() => {
    fetchAllTagCategory();
  }, [id]);

  const initialValues = {
    tag_name: "",
    description: "",
  };

  const handleSubmit = async (values) => {
    try {
      const formData = {
        tag_id: id,
        name: values.tag_name,
        description: values.description,
      };

      const res = await create_tags_category(formData);

      if (res.status === 201) {
        showToast("Tag created", "success");
        setVisibleModal(false);
        fetchAllTagCategory();
      }
    } catch (err) {
      console.error("Error creating tags", err);
      showToast("Failed to update settings", "error");
    }
  };

  const validationSchema = Yup.object({
    tag_name: Yup.string().required("name is required"),
    description: Yup.string().required("Description is required"),
  });

  return (
    <>
      <Card
        className={cn(styles.card)}
        title={tag?.name}
        classTitle="title-green"
        head={
          <button
            className={cn("button-stroke")}
            onClick={() => navigate("/settingsDashboard/tags")}
          >
            <Icon name="arrow-left" size="24" />
            <span>Back</span>
          </button>
        }
      >
        <div className={styles.list}>
          <Table
            data={tagCategory}
            className={styles.table}
            activeTable={visible}
            setActiveTable={setVisible}
          />
        </div>
        <Modal visible={visibleModal} onClose={() => setVisibleModal(false)}>
          <Formik
            initialValues={initialValues}
            enableReinitialize
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ values }) => (
              <Form>
                <Card
                  className={cn(styles.card)}
                  title="Create a Tag"
                  classTitle="title-green"
                >
                  <div className={styles.description}>
                    <Field name="tag_name">
                      {({ field, meta }) => (
                        <TextInput
                          {...field}
                          value={values.tag_name}
                          label="Tag Name"
                          tooltip="Maximum 100 characters. No HTML or emoji allowed"
                          className={styles.field}
                          error={meta.touched && meta.error ? meta.error : ""}
                        />
                      )}
                    </Field>
                  </div>
                  <div className={styles.description}>
                    <Field name="description">
                      {({ field, meta }) => (
                        <TextInput
                          {...field}
                          value={values.description}
                          label="Description"
                          tooltip="Maximum 100 characters. No HTML or emoji allowed"
                          className={styles.field}
                          error={meta.touched && meta.error ? meta.error : ""}
                        />
                      )}
                    </Field>
                  </div>
                  <div className={styles.btns}>
                    <button
                      className={cn("button-stroke", styles.button)}
                      onClick={() => setVisibleModal(false)}
                    >
                      <span>Cancel</span>
                    </button>
                    <button
                      className={cn("button", styles.button)}
                      onClick={(e) => {
                        e.preventDefault();
                        handleSubmit(values);
                      }}
                    >
                      Save
                    </button>
                  </div>
                </Card>
              </Form>
            )}
          </Formik>
        </Modal>
      </Card>
      <div className="fixed bottom-7 left-30 right-5">
        <Panel setVisibleModal={setVisibleModal} />
      </div>
    </>
  );
};

export default TagView;
